import React, { useContext } from "react";
import { TextField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import ModulesContext from "../Module/ModulesContext";
import Avatar from "@material-ui/core/Avatar";
import Skeleton from "@material-ui/lab/Skeleton";
import { Field } from "formik";
import "./styles.scss";

function ClientInfo() {
    const { clientPhoto } = useContext(ModulesContext);

    function renderPhoto() {
        if (clientPhoto) {
            return <Avatar variant="square" alt="Client Photo" src={clientPhoto} style={{ marginRight: 15 }} />;
        } else {
            return <Skeleton variant="rect" height={150} animation="pulse" />;
        }
    }

    return (
        <>
            <Grid item md={12} className="client-info-view">
                <Grid item md={3}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item className="avatar-container">
                            {renderPhoto()}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={9}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} sm={6} md={4} className="client-relevant-field">
                            <TextField disabled fieldName="client.lastName" label="Last Name" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className="client-relevant-field">
                            <TextField disabled fieldName="client.firstName" label="First Name" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className="client-relevant-field">
                            <TextField disabled fieldName="client.middleName" label="Middle Name" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField disabled fieldName="client.address" label="Address" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField disabled fieldName="client.city" label="City" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField disabled fieldName="client.state" label="State" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField disabled fieldName="client.zipCode" label="Zip Code" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            <TextField disabled fieldName="client.homePhone" label="Home Phone" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            <TextField disabled fieldName="client.workPhone" label="Work Phone" margin="dense" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={7}>
                            <TextField disabled fieldName="client.email" label="Email" margin="dense" lowercase />
                        </Grid>
                        <Grid item xs={12} style={{ display: "flex", flexDirection: "row-reverse" }}>
                            <Field>
                                {({ _, form }) =>
                                    form.values.client &&
                                    form.values.client.email && (
                                        <small>
                                            <a
                                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${String(form.values.client.email)
                                                    .trim()
                                                    .toLowerCase()}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Send email
                                            </a>
                                        </small>
                                    )
                                }
                            </Field>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default ClientInfo;
